import { ExternalLink } from "ui/Link";

export function FBAccountLink({
  account,
}: {
  account: { id: string; name: string };
}) {
  return (
    <ExternalLink href={`https://facebook.com/${account.id}`}>
      {account.name}
    </ExternalLink>
  );
}
